var _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 50,
    viewBox: "0 0 54 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.6304,
    cy: 25,
    rx: 26.6304,
    ry: 25,
    fill: "#5648B6",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4263_3345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9185 18.2282L27.1237 9.80428C26.9713 9.72315 26.8013 9.68073 26.6287 9.68073C26.4561 9.68073 26.2862 9.72315 26.1338 9.80428L10.339 18.2282C10.1705 18.318 10.0296 18.4519 9.93139 18.6156C9.83315 18.7792 9.78125 18.9665 9.78125 19.1575C9.78125 19.3484 9.83315 19.5357 9.93139 19.6994C10.0296 19.863 10.1705 19.9969 10.339 20.0867L13.9929 22.0361V28.4093C13.9918 28.9265 14.1821 29.4258 14.5273 29.8111C16.2515 31.7315 20.1147 34.9523 26.6287 34.9523C28.7886 34.9702 30.9324 34.5789 32.9467 33.7993V38.1113C32.9467 38.3905 33.0576 38.6584 33.2551 38.8558C33.4526 39.0533 33.7204 39.1642 33.9997 39.1642C34.2789 39.1642 34.5468 39.0533 34.7442 38.8558C34.9417 38.6584 35.0527 38.3905 35.0527 38.1113V32.7818C36.4258 31.9892 37.6666 30.9868 38.7302 29.8111C39.0754 29.4258 39.2657 28.9265 39.2646 28.4093V22.0361L42.9185 20.0867C43.087 19.9969 43.2279 19.863 43.3261 19.6994C43.4243 19.5357 43.4762 19.3484 43.4762 19.1575C43.4762 18.9665 43.4243 18.7792 43.3261 18.6156C43.2279 18.4519 43.087 18.318 42.9185 18.2282ZM26.6287 32.8463C20.9334 32.8463 17.5836 30.0638 16.0989 28.4093V23.1588L26.1338 28.5106C26.2862 28.5918 26.4561 28.6342 26.6287 28.6342C26.8013 28.6342 26.9713 28.5918 27.1237 28.5106L32.9467 25.4056V31.5051C31.2882 32.279 29.198 32.8463 26.6287 32.8463ZM37.1586 28.404C36.5274 29.1044 35.8212 29.7334 35.0527 30.2796V24.2816L37.1586 23.1588V28.404ZM34.5262 22.1769L34.4972 22.1598L27.1263 18.2282C26.8804 18.1026 26.5949 18.0786 26.3315 18.1614C26.0681 18.2442 25.8477 18.4272 25.7179 18.671C25.5881 18.9147 25.5592 19.1997 25.6375 19.4645C25.7158 19.7293 25.895 19.9528 26.1365 20.0867L32.2886 23.3694L26.6287 26.3875L13.0715 19.1575L26.6287 11.9274L40.186 19.1575L34.5262 22.1769Z",
    fill: "#5648B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4263_3345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6957,
    height: 31.6327,
    fill: "white",
    transform: "translate(9.78125 9.18396)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraining);
export default __webpack_public_path__ + "static/media/training.8a79883e9b2d4477a94442899458cf58.svg";
export { ForwardRef as ReactComponent };